import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';

export const useAddAccountToPartner = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ partnerId, accountId }: { partnerId: string; accountId: string }) =>
      accountsService.addAccountToPartner(partnerId, accountId),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.accounts.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const addAccountToPartner = async (
    partnerId: string,
    accountId: string
  ): Promise<string | null> => {
    try {
      return await mutation.mutateAsync({ partnerId, accountId });
    } catch {
      return null;
    }
  };

  return {
    addAccountToPartner,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useAddAccountToPartner;
